import { Component, computed, inject } from '@angular/core';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';
import { AvCardComponent } from '../../../../Shared/Components/av-card/av-card.component';
import { AvContentContainerComponent } from '../../../../Shared/Components/av-content-container/av-content-container.component';
import { ShowUserFacade } from '../../../../../Facades/Intune/show-user.facade';
import { AvCardField } from '../../../../Shared/Interfaces/av-card.interface';
import { AvLoadingItemComponent } from '../../../../Shared/Components/av-loading-item/av-loading-item.component';

@Component({
  selector: 'app-overview',
  standalone: true,
  imports: [COMMON_IMPORTS, AvCardComponent, AvContentContainerComponent, AvLoadingItemComponent],
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
})
export class OverviewComponent {
  private readonly _facade = inject(ShowUserFacade);

  readonly user = this._facade.user;

  readonly personalFields = computed<AvCardField[]>(() => {
    const user = this.user();
    if (!user) return [];
    return [
      { label: 'app.user.overview.sections.personal.fields.display_name', value: user.displayName ?? null },
      { label: 'app.user.overview.sections.personal.fields.user_principal_name', value: user.userPrincipalName ?? user.mail ?? null },
      { label: 'app.user.overview.sections.personal.fields.mobile_phone', value: user.mobilePhone ?? null },
      { label: 'app.user.overview.sections.personal.fields.employee_id', value: user.employeeId ?? null },
      { label: 'app.user.overview.sections.personal.fields.business_phone', value: user.businessPhones?.[0] ?? null },
    ];
  });

  readonly organizationFields = computed<AvCardField[]>(() => {
    const user = this.user();
    if (!user) return [];
    return [
      { label: 'app.user.overview.sections.organization.fields.job_title', value: user.jobTitle ?? null },
      { label: 'app.user.overview.sections.organization.fields.department', value: user.department ?? null },
      { label: 'app.user.overview.sections.organization.fields.office_location', value: user.officeLocation ?? null },
      { label: 'app.user.overview.sections.organization.fields.manager', value: user?.manager?.displayName ?? null, routerLink: user.manager?.id ? ['/users', user.manager.id] : undefined },
      { label: 'app.user.overview.sections.organization.fields.manager_email', value: user?.manager?.userPrincipalName, routerLink: user.manager?.id ? ['/users', user.manager.id] : undefined },
    ];
  });
}
